import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("hg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const fmtEUR = (n) => `${Number(n || 0).toFixed(2)} €`;

export const mediaUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  // legacy paths saved as /uploads/... need to be rewritten to /api/uploads/... for ingress routing
  const path = u.startsWith("/uploads/") ? `/api${u}` : u;
  return `${BACKEND_URL}${path}`;
};
